import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { AppDto } from '../dtos/app.dto';
import { AppTableModel } from '../models/app-table.model';
import { mapAppDtoToAppTableModel } from '../utils/mapping.utils';

export const deleteApp: AsyncThunk<
  AppTableModel,
  number,
  Record<number, unknown>
> = createAsyncThunk('apps/delete-app', async (id: number) => {
  const basePath = `/apps/${id}`;
  const resp: AxiosResponse<AppDto> = await axiosInstance.delete(basePath);
  return mapAppDtoToAppTableModel(resp.data);
});
